import { Skeleton as PrimeSkeleton } from "primereact/skeleton";
import { forwardRef } from "react";

import { rootStylePt } from "../../utils/root-style-pt";
import type { SkeletonProps } from "./types-skeleton";

// figma: skeleton (373:13726) tem 14 de altura (`--ds-size-skeleton-line`); o padrão do Prime é 1rem (16), aplicado inline.
const SKELETON_HEIGHT = "var(--ds-size-skeleton-line)";

/** `Skeleton` do Prime (o `style` da tela vai para a raiz por `pt.root`: o Prime 10.9.8 o ignora); cor e raio do bloco vêm do tema (frame `skeleton` do Figma). `TableSkeleton` e `CardSkeleton` o usam por dentro. */
export const Skeleton = forwardRef<PrimeSkeleton, SkeletonProps>(function Skeleton(
  { style, pt, height = SKELETON_HEIGHT, ...props },
  ref,
) {
  return <PrimeSkeleton ref={ref} height={height} {...props} pt={rootStylePt(pt, style)} />;
});
Skeleton.displayName = "Skeleton";
